import { createStore } from '@tanstack/react-store'
import type { CommentListOrder } from '@/@types/comment'

const commentOrderStore = createStore<CommentListOrder>('LIKES')

export default commentOrderStore
